/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M16 5.00024H9C6.79086 5.00024 5 6.79111 5 9.00024V9.00024M16 19.0002H9C6.79086 19.0002 5 17.2094 5 15.0002V15.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 5.00024C16 3.34339 17.3431 2.00024 19 2.00024C20.6569 2.00024 22 3.34339 22 5.00024C22 6.6571 20.6569 8.00024 19 8.00024C17.3431 8.00024 16 6.6571 16 5.00024Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 12.0002C2 10.3434 3.34315 9.00024 5 9.00024C6.65685 9.00024 8 10.3434 8 12.0002C8 13.6571 6.65685 15.0002 5 15.0002C3.34315 15.0002 2 13.6571 2 12.0002Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16 19.0002C16 17.3434 17.3431 16.0002 19 16.0002C20.6569 16.0002 22 17.3434 22 19.0002C22 20.6571 20.6569 22.0002 19 22.0002C17.3431 22.0002 16 20.6571 16 19.0002Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<g opacity="0.12">
				<path
					d="M16 5.00024C16 3.34339 17.3431 2.00024 19 2.00024C20.6569 2.00024 22 3.34339 22 5.00024C22 6.6571 20.6569 8.00024 19 8.00024C17.3431 8.00024 16 6.6571 16 5.00024Z"
					fill="currentColor"
				/>
				<path
					d="M2 12.0002C2 10.3434 3.34315 9.00024 5 9.00024C6.65685 9.00024 8 10.3434 8 12.0002C8 13.6571 6.65685 15.0002 5 15.0002C3.34315 15.0002 2 13.6571 2 12.0002Z"
					fill="currentColor"
				/>
				<path
					d="M16 19.0002C16 17.3434 17.3431 16.0002 19 16.0002C20.6569 16.0002 22 17.3434 22 19.0002C22 20.6571 20.6569 22.0002 19 22.0002C17.3431 22.0002 16 20.6571 16 19.0002Z"
					fill="currentColor"
				/>
			</g>
			<path
				d="M16 5C16 6.65685 17.3431 8 19 8C20.6569 8 22 6.65685 22 5C22 3.34315 20.6569 2 19 2C17.3431 2 16 3.34315 16 5ZM16 5H9C6.79086 5 5 6.79086 5 9V9M5 15C3.34315 15 2 13.6569 2 12C2 10.3431 3.34315 9 5 9M5 15C6.65685 15 8 13.6569 8 12C8 10.3431 6.65685 9 5 9M5 15V15C5 17.2091 6.79086 19 9 19H16M16 19C16 20.6569 17.3431 22 19 22C20.6569 22 22 20.6569 22 19C22 17.3431 20.6569 16 19 16C17.3431 16 16 17.3431 16 19Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.325 5.75001L11 5.75001C9.00126 5.75001 7.26339 6.86695 6.37652 8.5107C7.76654 9.05951 8.75 10.4149 8.75 12C8.75 13.5851 7.76654 14.9405 6.37652 15.4893C7.26339 17.1331 9.00125 18.25 11 18.25L15.325 18.25C15.6725 16.5383 17.1858 15.25 19 15.25C21.0711 15.25 22.75 16.9289 22.75 19C22.75 21.0711 21.0711 22.75 19 22.75C17.1858 22.75 15.6725 21.4617 15.325 19.75L11 19.75C8.25002 19.75 5.88414 18.1055 4.8321 15.7463C2.83895 15.6585 1.25 14.0148 1.25 12C1.25 9.9852 2.83895 8.34151 4.8321 8.25369C5.88414 5.89449 8.25002 4.25001 11 4.25001L15.325 4.25001C15.6725 2.53833 17.1858 1.25 19 1.25C21.0711 1.25 22.75 2.92894 22.75 5C22.75 7.07107 21.0711 8.75 19 8.75C17.1858 8.75 15.6725 7.46169 15.325 5.75001Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M5 15.0002C3.34315 15.0002 2 13.6571 2 12.0002C2 10.3434 3.34315 9.00024 5 9.00024M5 15.0002C6.65685 15.0002 8 13.6571 8 12.0002C8 10.3434 6.65685 9.00024 5 9.00024M5 15.0002V15.0002C5 17.2094 6.79086 19.0002 9 19.0002H13M5 9.00024V9.00024C5 6.79111 6.79086 5.00024 9 5.00024H13M19 8.00024C17.3431 8.00024 16 6.6571 16 5.00024C16 3.34339 17.3431 2.00024 19 2.00024C20.6569 2.00024 22 3.34339 22 5.00024C22 6.6571 20.6569 8.00024 19 8.00024ZM19 22.0002C17.3431 22.0002 16 20.6571 16 19.0002C16 17.3434 17.3431 16.0002 19 16.0002C20.6569 16.0002 22 17.3434 22 19.0002C22 20.6571 20.6569 22.0002 19 22.0002Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M16 5.00024C16 6.6571 17.3431 8.00024 19 8.00024C20.6568 8.00024 22 6.6571 22 5.00024C22 3.34339 20.6568 2.00024 19 2.00024C17.3431 2.00024 16 3.34339 16 5.00024ZM16 5.00024H8.99999C6.79085 5.00024 4.99998 6.79111 4.99998 9.00024V9.00024M4.99998 15.0002C3.34313 15.0002 1.99998 13.6571 1.99998 12.0002C1.99998 10.3434 3.34313 9.00024 4.99998 9.00024M4.99998 15.0002C6.65684 15.0002 7.99998 13.6571 7.99998 12.0002C7.99998 10.3434 6.65684 9.00024 4.99998 9.00024M4.99998 15.0002V15.0002C4.99998 17.2094 6.79085 19.0002 8.99999 19.0002H16M16 19.0002C16 20.6571 17.3431 22.0002 19 22.0002C20.6568 22.0002 22 20.6571 22 19.0002C22 17.3434 20.6568 16.0002 19 16.0002C17.3431 16.0002 16 17.3434 16 19.0002Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.25003 11.0002C4.25003 7.27232 7.27211 4.25025 11 4.25025L16 4.25025C16.4142 4.25025 16.75 4.58603 16.75 5.00025C16.75 5.41446 16.4142 5.75025 16 5.75025L11 5.75025C8.10053 5.75025 5.75003 8.10075 5.75003 11.0002C5.75003 11.4145 5.41424 11.7502 5.00003 11.7502C4.58582 11.7502 4.25003 11.4145 4.25003 11.0002ZM5.00003 12.2502C5.41424 12.2502 5.75003 12.586 5.75003 13.0002C5.75003 15.8997 8.10054 18.2502 11 18.2502L16 18.2502C16.4142 18.2502 16.75 18.586 16.75 19.0002C16.75 19.4145 16.4142 19.7502 16 19.7502L11 19.7502C7.27211 19.7502 4.25003 16.7282 4.25003 13.0002C4.25003 12.586 4.58582 12.2502 5.00003 12.2502Z"
				fill="currentColor"
			/>
			<path
				d="M19 1.25C16.9289 1.25 15.25 2.92893 15.25 5C15.25 7.07107 16.9289 8.75 19 8.75C21.0711 8.75 22.75 7.07107 22.75 5C22.75 2.92893 21.0711 1.25 19 1.25Z"
				fill="currentColor"
			/>
			<path
				d="M1.25 12C1.25 9.92893 2.92893 8.25 5 8.25C7.07107 8.25 8.75 9.92893 8.75 12C8.75 14.0711 7.07107 15.75 5 15.75C2.92893 15.75 1.25 14.0711 1.25 12Z"
				fill="currentColor"
			/>
			<path
				d="M19 15.25C16.9289 15.25 15.25 16.9289 15.25 19C15.25 21.0711 16.9289 22.75 19 22.75C21.0711 22.75 22.75 21.0711 22.75 19C22.75 16.9289 21.0711 15.25 19 15.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
